// Helper: prefix assets with PUBLIC_URL so they resolve correctly both
// when the build is opened via file:// and when served from a domain.
// process.env.PUBLIC_URL is set by Create React App based on `homepage`
// field in package.json. With homepage="." it becomes "." (relative).
const PUBLIC = process.env.PUBLIC_URL || "";

export function asset(path) {
  // Allow callers to pass either "/assets/..." or "assets/..."
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `${PUBLIC}${clean}`;
}
